import React, { useEffect, useMemo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppNavigator from './AppNavigator'
import AffiliateTracker from './components/AffiliateTracker'
// import FirebaseAnalytics from './FirebaseAnalytics'
// import CookieConsent from 'react-cookie-consent'
import { AppconfigContext } from './appconfig-context'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { connect } from 'react-redux'
import { compose } from 'redux'
// import TawkTo from './components/TawkTo'
import moment from 'moment'
import { useInterval } from './utils/useInterval'
import { useVenueResources } from './utils/useVenueResources'

function App({ appconfig, auth, profile, dispatch }) {
  const [ac, setAc] = React.useState(appconfig)

  useMemo(() => {
    if (JSON.stringify(ac) !== JSON.stringify(appconfig)) {
      setAc(appconfig)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appconfig])


  useInterval(() => {
    fetch('/favicon.ico?_cb=' + Date.now(), { method: 'HEAD' }).then((response) => {
      const time = moment(new Date(response.headers.get('Date')))
      dispatch({
        type: 'UPDATE_GLOBALTIME',
        payload: time,
      })
    })
  }, 60000)


  useEffect(() => {
    fetch('/favicon.ico?_cb=' + Date.now(), { method: 'HEAD' }).then((response) => {
      const time = moment(new Date(response.headers.get('Date')))
      dispatch({
        type: 'UPDATE_GLOBALTIME',
        payload: time,
      })
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  // Every page gets the venue's full resource list from getResources, whatever the init doc embeds:
  // see utils/useVenueResources.js. It waits for the account, so a page opened directly (own
  // reservations) gets the list too - a mount-only fetch ran before the init doc was read.
  useVenueResources({ appconfig })





  if (appconfig && isLoaded(appconfig)) {
    // console.log('appconfig', appconfig)
    return (
      <AppconfigContext.Provider value={ac}>
        <BrowserRouter>
          <AppNavigator />
          <AffiliateTracker />
          {/* <FirebaseAnalytics /> */}
          {/* {appconfig.tawkto ? <TawkTo profile={profile} {...appconfig.tawkto} /> : null} */}
          {/* <CookieConsent
        location='bottom'
        buttonText='Ok'
        cookieName='fa-cookie-consent'
        style={{ background: '#7a7a7a', borderRadius: 5 }}
        buttonStyle={{ color: '#4e503b', fontSize: '13px', borderRadius: 5 }}
        expires={150}
      >
        Käytämme . <span style={{ fontSize: '10px' }}>This bit of text is smaller :O</span>
      </CookieConsent> */}
        </BrowserRouter>
      </AppconfigContext.Provider>
    )
  } else {
    return <></>
  }
}

const withConfig = compose(
  connect(({ firebase: { auth, profile } }) => ({
    auth,
    profile,
  })),
  firestoreConnect((props) => [
    {
      collection: 'inits',
      where: [
        ['type', '==', 'webr'],
        document.location.hostname === 'utest.cintoia.com' || document.location.hostname === 'localhost'
          ? ['utest', '==', document.location.pathname.split('/')[1]]
          : ['hosts', 'array-contains', document.location.hostname],
      ],
      storeAs: 'init',
    }]),
  connect(({ firestore, resources }) => {
    if (firestore.data['init']) {
      const _appconfigs = Object.keys(firestore.data['init'])
      const appconfig = _appconfigs.map((a) => {
        return { ...firestore.data['init'][a] }
      })[0]

      if (document.location.hostname === 'utest.cintoia.com' || document.location.hostname === 'localhost') {
        appconfig.pathPrefix = '/' + appconfig.utest
      } else {
        appconfig.pathPrefix = ''
      }
      appconfig.isOnlyMembers = (appconfig.onlyMembers && appconfig.onlyMembers.memberships && appconfig.onlyMembers.memberships.length > 0) ? true : false
      appconfig.reservationsOnlyMembers = (appconfig.onlyMembers && appconfig.onlyMembers.reservations && appconfig.onlyMembers.reservations.length > 0) ? true : false
      if (appconfig.reservationsOnlyMembers) appconfig.isOnlyMembers = true
      appconfig.activitiesOnlyMembers = (appconfig.onlyMembers && appconfig.onlyMembers.activities && appconfig.onlyMembers.activities.length > 0) ? true : false

      // getResources' list wins over the init doc's embedded copy, which can be partial
      // (configsync.js only copies resources as they are written). The copy stays as a stand-in
      // until the list arrives.
      appconfig.resources = (resources && resources.resources) || appconfig.resources || null

      return {
        appconfig,
      }
    } else {
      return {
        appconfig: null,
      }
    }
  })
)

export default withConfig(App)
